<template>
  <div
    v-if="attachmentOptions && attachmentOptions.length"
    class="file-uploaded"
  >
    <div class="file clickable flex-row flex__between padding-left-10">
      <a
        class="flex-row flex__left"
        @click="downloadDoc(attachmentOptions[0].attachment)"
      >
        <fileTypeImage
          :fileExtention="attachmentOptions[0].attachment.fileExtention"
        />
        <span class="fileName font-weight_normal">{{
            attachmentOptions[0].label
          }}</span>
      </a>
      <a
        class="clickable icon-download-file margin-right-10"
        @click="downloadDoc(attachmentOptions[0].attachment)"
      >
        <i class="fas fa-cloud-download color__white font-size__medium"></i>
      </a>

      <div v-if="attachmentOptions.length > 1" class="dropdown-file">
        <el-dropdown
          class="dropdown-file-icon flex-row flex__center"
          trigger="hover"
        >
          <div class="el-dropdown-link width__100 flex-row flex__between">
            <i
              class="el-icon-caret-bottom el-icon--right margin-right-10 padding-right-10"
            ></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="clearfix">
              Danh sách file
            </el-dropdown-item>
            <el-dropdown-item
              v-for="(attachmentOption, index) in attachmentOptions"
              v-if="index > 0"
              :key="attachmentOption.type"
              class="clearfix flex-row flex__left"
            >
              <div class="margin-right-5">{{ index }}.&nbsp;</div>
              <div class="file-uploaded style-fullWidth">
                <div
                  class="file clickable flex-row flex__between padding-left-10 style-fullWidth"
                  @click="downloadDoc(attachmentOption.attachment)"
                >
                  <a class="file-name flex-row flex__left">
                    <file-type-image
                      :fileExtention="attachmentOption.attachment.fileExtention"
                    />
                    <span class="fileName font-weight_normal">{{
                        attachmentOption.label
                      }}</span>
                  </a>
                  <a
                    class="clickable icon-download-file margin-right-10 flex__right"
                  >
                    <i
                      class="fas fa-cloud-download color__white font-size__medium"
                    ></i>
                  </a>
                </div>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import attachmentService from "../../services/attachmentService";
import constants from "../../constants";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import FileTypeImage from "../job/FileTypeImage";
import errorMessageFilter from "../../filters/errorMessageFilter";
import downloadService from "../../services/downloadService";

export default {
  name: "vbdi-download-files-for-config-ld",
  components: {FileTypeImage},
  props: ["userDeptRoleId", "docId", "isConfigLD"],
  data() {
    return {
      userDeptRole: null,
      attachmentOptions: null
    };
  },

  watch: {
    docId() {
      this.loadUserDeptRole().then(() => this.initAttachment());
    }
  },

  created() {
    this.loadUserDeptRole().then(() => this.initAttachment());
  },

  methods: {
    loadUserDeptRole() {
      return userDeptRoleViewService
        .findById(this.userDeptRoleId)
        .then(response => (this.userDeptRole = response.data));
    },

    async initAttachment() {
      const attachmentObjectTypes = [
        constants.ATTACHMENT_OBJECT_TYPE.VB_DI_REFERENCE_ATTACHMENT,
        constants.ATTACHMENT_OBJECT_TYPE.VB_DI

      ];

      const promises = [];

      for (let i = 0; i < attachmentObjectTypes.length; i++) {
        promises.push(this.loadAttachment(attachmentObjectTypes[i]))
      }

      await Promise.all(promises)
      .then(res => {
        let vbDiReferenceAttachment = res[0];
        let vbDiAttachment = res[1];

        this.attachmentOptions = [];

        if (vbDiReferenceAttachment) {
          this.attachmentOptions.push({
            type: vbDiReferenceAttachment.objectType,
            attachment: vbDiReferenceAttachment,
            label: errorMessageFilter({
              errorCode: "vbAttachment.objectType.vbDiReference"
            })
          });
        }

        this.attachmentOptions.push({
          type: vbDiAttachment.objectType,
          attachment: vbDiAttachment,
          label: errorMessageFilter({
            errorCode: "vbAttachment.objectType.vbDi"
          })
        });
      })
    },

    loadAttachment(objectType) {
      return attachmentService
        .findAll({objectId: this.docId, objectType: objectType})
        .then(response =>
          response.data && response.data.length ? response.data[0] : null
        );
    },

    downloadDoc(attachment) {
      downloadService.downloadOutgoingDocForConfigLD(attachment.objectId, attachment.objectType);
    }
  }
};
</script>

<style scoped>
.file-uploaded {
  max-width: 310px;
}
.file-uploaded .file-name {
  width: calc(100% - 42px);
  flex: 0 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/vbdi-download-files-for-config-ld.vue